export enum SignUpForm {
    signupPlaceholderFirstname = 'Ime',
    signupPlaceholderLastname = 'Prezime',
    signupPlaceholderName = 'Naziv',
    signupPlaceholderAddress = 'Adresa',
    signupPlaceholderPhone = 'Broj telefona',
    signupPlaceholderEmail = 'E-mail adresa',
    signupPlaceholderUserName = 'Korisnicko ime',
    signupPlaceholderPassword = 'Lozinka',
    signupPlaceholderConfirmPassword = 'Ponovljena lozinka',
    signupFormSubmitButton = 'Registrujte se',
    signupFormTitle = 'Registracija',
    signupSuccessMessage = 'Uspešno ste se registrovali!',
    signupFailedMessage = 'Došlo je do greške prilikom regisracije, pokušajte ponovo!',
    signupPlaceholderCompanyName = 'Naziv firme',
    signupPlaceholderRegistrationNumber = 'Matični broj',
    signupPlaceholderRegistrationDate = 'Datum registracije',
    signupPlaceholderPib = 'PIB',
    signupPlaceholderBankAccount = 'Broj računa',
    signupPersonalInfoTitle = 'Lični podaci',
    signupCompanyInfoTitle = 'Podaci o firmi',
    signupModeOfTransport = 'Vrsta transporta',
    signupOwnTransport = 'Sopstveni prevoz',
    signupSpecial = 'Specijalni prevoz',
    signupCommercial = 'Komercijalni prevoz'
}